<template>
  <div :class="[!metaFailed ? 'url-metadata' : 'url-meta-failed']">
    <template v-if="!metaFailed">
      <q-spinner v-if="!isFinish" class="url-metadata-spinner" color="lale-gray" size="3em" />
      <a v-if="isFinish" :href="url">
        <img :src="urlCover" @error="selDefaultImg()" />
        <!-- <div v-else class="url-img" v-html="urlCover"></div> -->
        <div class="url-info">
          <div class="url-title overflow-ellipsis" v-html="title || url"></div>
          <div class="url-description overflow-ellipsis-2" v-html="description || '無描述'"></div>
        </div>
      </a>
    </template>
    <template v-else>
      <a :href="url" v-if="!content.includes(url)">{{ url }}</a>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'UrlMetadata',
  data() {
    return {
      isFinish: false,
      title: '',
      description: '',
      urlCover: '',
      defaultImg: require('@/assets/img/default_link.jpg'),
      metaFailed: false
    };
  },
  props: ['url', 'content'],
  mounted() {
    this.getUrlMetadata();
  },
  methods: {
    // 透過外部 API 服務解析 url 的 metadata
    getUrlMetadata() {
      let isYouTube = this.url.indexOf('youtu.be') > -1 || this.url.indexOf('youtube.com') > -1;
      let api = `https://url-metadata.herokuapp.com/api/metadata?url=${this.url}`;
      // youtube 網址使用特定的 API 做解析
      if (isYouTube) {
        api = `https://www.youtube.com/oembed?url=${this.url}&format=json`;
      }
      axios
        .get(api)
        .then(res => {
          if (isYouTube) {
            // 適用 youtube 的解析格式
            let urlData = res.data;
            this.description = urlData.author_name;
            this.title = urlData.title;
            this.urlCover = urlData.thumbnail_url;
            this.isFinish = true;
          } else {
            let urlData = res.data.data;
            this.description = urlData.description;
            this.title = urlData.title;
            this.urlCover = decodeURI(urlData.image) || urlData.favicon;
            this.isFinish = true;
          }
        })
        .catch(err => {
          console.log(err);
          this.metaFailed = true;
          this.isFinish = true;
        });
    },
    // 死圖時給預設圖片
    selDefaultImg() {
      // debugger;
      // this.noBase64 = false;
      // return (this.urlCover = `<img src="${decodeURI(encodeURI(this.urlCover))}"/>`);
      return (this.urlCover = this.defaultImg);
    }
  }
};
</script>

<style scoped lang="scss">
.url-metadata {
  min-height: 236px;
  position: relative;
  .url-metadata-spinner {
    position: absolute;
    top: 50%;
    left: calc(50% - 20px);
    transform: translateX(-50%) translateY(-50%);
  }

  img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 6px 6px 0 0;
    overflow: hidden;
  }
}

.url-info {
  background-color: #f6f8f4;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  margin-top: -5px;
}

.url-title {
  font-size: 16px;
  font-weight: 700;
  color: $LaleTitleBlack;
}

.url-description {
  color: $LaleGray8;
}
.url-meta-failed {
  min-height: 0;
  word-break: break-all;
}
</style>
<style lang="scss">
.url-img {
  width: 100%;
  height: 180px;
  border-radius: 6px 6px 0 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
